import React from 'react';
import {Route, Routes, BrowserRouter} from 'react-router-dom';

import Home from './pages/homepage';
import Services from './pages/services';
import ServiceDetail from './pages/serviceDetailPage'; 
import DoctorProfile from './pages/doctorProfile'; 
import About from './pages/about';
import Header from "./components/Header";   
import Footer from "./components/Footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ScrollToTop from "./ScrollToTop";  
import Careers from "./pages/Careers";

import './App.css';
import Gallery from './pages/gallery';


function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Header />     

      <Routes>
        <Route path='/' element = {<Home/>} />
        <Route path='/services/:serviceId' element = {<ServiceDetail/>} />
        <Route path ='/doctors/:doctorId' element = {<DoctorProfile/>} />
        <Route path='/services' element = {<Services/>}/>
        <Route path='/about' element = {<About/>}/>
        <Route path='/gallery' element = {<Gallery/>}/>
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/careers" element={<Careers />} />


      </Routes>

      <Footer />

    </BrowserRouter>
  );
}

export default App;
